<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="ad_card" id="ad_card_1">
<p class="ach"><a href="#/NoControl_toc#ad_card_1">ALSO BY SHANNON K. BUTCHER</a></p>
<p class="acl"><em>No Regrets</em></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoControl_ad_card_1.vue?1ddcbf94